import React from "react";
import Barcode from 'react-barcode';

/**
 * @param {Upc_Center_Object} product
 */
export default ({product}) => {
	let value = product.upc;

	//These same values should be good.
	let maxCharacters = 16;
	let minCharacters = 5;

	let cutBarCodeText = (text)=> {
		return text.substr(0, maxCharacters);
	};
	let cutBarCodeTextExtra = (text)=> {
		return ' ' + text.substr(maxCharacters);
	};
	let getBarCodeWidth = (text) => {
		let smallest = 1.3;
		let largest = 2.3;
		let range = largest - smallest;
		let charRange = maxCharacters - minCharacters;
		let widthSegmentPerCharacter = range / charRange;
		let charsOverMin = text.length - minCharacters;
		let additionalSize = widthSegmentPerCharacter * charsOverMin;
		let newSize = largest - additionalSize;
		return Math.min(Math.max(newSize, smallest), largest);
	};

	return (
		<div className="UpcShort pageBreak" style={{textAlign: 'center'}}>
			<div className="serialNumber" style={{padding:"5px",fontSize:"20px", textAlign: 'center'}}>
				{product.upc}
			</div>
			<div className="barCode">
				<Barcode format={'CODE128A'}
				         value={cutBarCodeText(value)}
				         height={30}
				         margin={0}
				         width={getBarCodeWidth(value)}
				         displayValue={false} />
			</div>
			<b>{cutBarCodeText(value)}</b>{cutBarCodeTextExtra(value)}<br/>
		</div>
	);
}
